import {Notification} from "../classes/Notification";

const NotificationPlugin = {
    install(Vue, options) {
        Vue.component('toast', require('../components/Toast.vue').default);
        Vue.component('toast-container', require('../components/ToastContainer.vue').default);

        Vue.prototype.$notifications = new Notification();
    }
};

export default NotificationPlugin;
